(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peiks-collection-heading"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = () => document.querySelectorAll('[data-peiks-category-counter]:not([data-count-started])').forEach(async root => {
      root.dataset.countStarted = 'true';
      const status = root.querySelector('[data-category-count-status]');
      const readPage = async page => {
        const url = new URL(root.dataset.collectionUrl, location.origin);
        url.searchParams.set('section_id', 'peiks-collection-count');
        url.searchParams.set('page', String(page));
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Zähler nicht erreichbar');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const chunk = html.querySelector('[data-peiks-category-count-page]');
        if (!chunk) throw new Error('Zählerabschnitt fehlt');
        const values = ['page', 'total', 'count', 'variants'].map(key => Number(chunk.dataset[key]));
        if (!values.every(Number.isSafeInteger) || values.some(value => value < 0) || values[0] !== page || values[3] < values[2]) throw new Error('Ungültige Zählwerte');
        if (!['true', 'false'].includes(chunk.dataset.complete) || !['true', 'false'].includes(chunk.dataset.hasNext)) throw new Error('Unvollständiger Zähler');
        return {
          page,
          total: values[1],
          products: values[2],
          variants: values[3],
          complete: chunk.dataset.complete === 'true',
          hasNext: chunk.dataset.hasNext === 'true'
        };
      };
      try {
        const first = await readPage(1);
        const pageCount = Math.max(1, Math.ceil(first.total / 50));
        if (pageCount > 100) throw new Error('Kategorie zu groß für diesen Zähler');
        const pages = [first];
        let next = 2;
        await Promise.all(Array.from({ length: Math.min(4, pageCount - 1) }, async () => {
          while (next <= pageCount) pages.push(await readPage(next++));
        }));
        if (!root.isConnected || pages.length !== pageCount || pages.some(item => item.total !== first.total || item.hasNext !== (item.page < pageCount))) throw new Error('Zählung unvollständig');
        const products = pages.reduce((sum, item) => sum + item.products, 0);
        const variants = pages.reduce((sum, item) => sum + item.variants, 0);
        const format = value => value.toLocaleString('de-DE');
        if (pages.every(item => item.complete)) {
          root.querySelector('[data-category-product-count]').textContent = format(products);
          root.querySelector('[data-category-product-label]').textContent = products === 1 ? 'Produkt' : 'Produkte';
          root.querySelector('[data-category-variant-count]').textContent = format(variants);
          root.querySelector('[data-category-variant-label]').textContent = variants === 1 ? 'Variante' : 'Varianten';
          root.querySelector('[data-category-count-line]').hidden = false;
          status.textContent = '';
        } else {
          status.textContent = `${format(products)} verfügbare Produkte · genaue Variantenanzahl zurzeit nicht verfügbar`;
        }
      } catch {
        if (root.isConnected) status.textContent = 'Verfügbare Zahlen zurzeit nicht abrufbar';
      }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peiks-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-peiks-footer]:not([data-footer-ready])').forEach(root => {
      root.dataset.footerReady = 'true';
      const desktop = window.matchMedia('(min-width: 901px)');
      const groups = Array.from(root.querySelectorAll('[data-footer-group]'));
      const mobileState = new WeakMap();
      const update = () => {
        groups.forEach(group => {
          if (desktop.matches) {
            mobileState.set(group, group.open);
            group.open = true;
          } else {
            group.open = mobileState.get(group) || false;
          }
        });
      };
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
        if (desktop.matches) event.preventDefault();
      }));
      update();
      const onChange = () => {
        if (!root.isConnected) {
          desktop.removeEventListener('change', onChange);
          return;
        }
        update();
      };
      desktop.addEventListener('change', onChange);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peiks-startseite"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('peiks-home')) {
  customElements.define('peiks-home', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('.ph-products, .ph-rail').forEach(rail => {
        const buttons = Array.from(this.querySelectorAll('[data-slide]')).filter(b => b.getAttribute('aria-controls') === rail.id);
        const update = () => {
          buttons.forEach(button => {
            button.disabled = Number(button.dataset.slide) < 0 ? rail.scrollLeft < 3 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
          });
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          rail.scrollBy({ left: Number(button.dataset.slide) * rail.clientWidth * .9, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, options));
        rail.addEventListener('scroll', update, { ...options, passive: true });
        window.addEventListener('resize', update, options);
        requestAnimationFrame(update);
      });
      const help = this.querySelector('[data-help]');
      if (help) {
        document.addEventListener('click', event => { if (!help.contains(event.target)) help.open = false; }, options);
        document.addEventListener('keydown', event => { if (event.key === 'Escape') help.open = false; }, options);
      }
      const delivery = this.querySelector('[data-delivery-details]');
      if (delivery) delivery.open = matchMedia('(min-width: 900px)').matches;
      const gallery = this.querySelector('[data-store-carousel]');
      if (gallery) {
        const slides = [...gallery.querySelectorAll('[data-store-slide]')];
        if (slides.length > 1) {
          let active = 0;
          const show = next => {
            active = (next + slides.length) % slides.length;
            slides.forEach((slide, index) => { slide.hidden = index !== active; });
            gallery.querySelector('[data-store-progress]').textContent = `${active + 1} / ${slides.length}`;
          };
          gallery.querySelector('[data-store-prev]').addEventListener('click', () => show(active - 1), options);
          gallery.querySelector('[data-store-next]').addEventListener('click', () => show(active + 1), options);
          if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.galleryInterval = window.setInterval(() => {
              if (document.hidden || gallery.matches(':hover') || gallery.matches(':focus-within')) return;
              show(active + 1);
            }, 5000);
          }
        }
      }
      const direct = this.querySelector('[data-direct-reviews]');
      if (direct && direct.dataset.endpoint) {
        const load = () => this.loadGoogleReviews(direct);
        if ('IntersectionObserver' in window) {
          this.googleObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { this.googleObserver.disconnect(); load(); }
          });
          this.googleObserver.observe(direct);
        } else load();
      }
      const counter = this.querySelector('[data-catalog-count]');
      if (counter) this.loadCatalogCount(counter);
      const countdown = this.querySelector('[data-cutoff-week]');
      if (countdown) {
        const refresh = () => this.updateCountdown(countdown);
        refresh();
        this.countdownInterval = window.setInterval(refresh, 30000);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); }, options);
      }
      const mount = this.querySelector('[data-review-mount]');
      const status = this.querySelector('[data-review-status]');
      const widgetId = this.dataset.widget;
      if (mount && /^googrev-id-\d+$/.test(widgetId)) {
        if (document.getElementById(widgetId) !== mount && status) status.textContent = 'Unsere Google-Bewertungen sind bereits an anderer Stelle dieser Seite eingebunden.';
        this.reviewObserver = new MutationObserver(() => { if (status && mount.children.length) status.hidden = true; });
        this.reviewObserver.observe(mount, { childList: true, subtree: true });
        if (status && mount.children.length) status.hidden = true;
      }
    }
    async syncCartIndicator() {
      const response = await fetch(`${this.dataset.cartRoot || '/'}cart.js`, { credentials: 'same-origin', signal: this.controller.signal });
      if (!response.ok) return;
      const cart = await response.json();
      const { CartUpdateEvent } = await import('@theme/events');
      document.dispatchEvent(new CartUpdateEvent(cart, 'peiks-quick-add', { itemCount: cart.item_count, source: 'peiks-quick-add', sections: {} }));
    }
    updateCountdown(box) {
      const now = new Date();
      const fields = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      }).formatToParts(now).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
      const day = fields.weekday;
      const weekend = day === 'Sat' || day === 'Sun';
      const cutoffText = weekend ? box.dataset.cutoffWeekend : box.dataset.cutoffWeek;
      const match = cutoffText?.match(/(\d{1,2})(?:[:.](\d{2}))?/);
      if (!match) {
        box.querySelector('[data-countdown-time]').textContent = `Bestellschluss: ${cutoffText || 'siehe Lieferinfos'}`;
        return;
      }
      const secondsNow = Number(fields.hour) * 3600 + Number(fields.minute) * 60 + Number(fields.second);
      const cutoff = (Number(match[1]) * 60 + Number(match[2] || 0)) * 60;
      const remaining = cutoff - secondsNow;
      const label = box.querySelector('[data-countdown-label]');
      const time = box.querySelector('[data-countdown-time]');
      if (remaining > 0) {
        label.textContent = 'Bis zum Bestellschluss heute';
        time.textContent = `${Math.floor(remaining / 3600)} Std. ${String(Math.floor(remaining % 3600 / 60)).padStart(2, '0')} Min.`;
      } else {
        label.textContent = 'Bestellschluss für heute vorbei';
        time.textContent = 'Jetzt bestellen · morgen geliefert';
      }
      const store = box.querySelector('[data-store-hours]');
      if (day === 'Sun') store.textContent = 'Store heute geschlossen · Lieferservice verfügbar';
      else {
        const close = day === 'Sat' ? 17 : 19;
        const open = 12;
        if (secondsNow < open * 3600) store.textContent = `Store öffnet um ${open} Uhr`;
        else if (secondsNow >= close * 3600) store.textContent = 'Store für heute geschlossen';
        else {
          const storeMinutes = Math.ceil((close * 3600 - secondsNow) / 60);
          store.textContent = `Store noch ${Math.floor(storeMinutes / 60)} Std. ${String(storeMinutes % 60).padStart(2, '0')} Min. geöffnet`;
        }
      }
    }
    async loadCatalogCount(root) {
      const signal = this.controller.signal;
      const status = root.querySelector('[data-count-status]');
      let page = 1, total = null, counted = 0, variants = 0, complete = true;
      try {
        for (;;) {
          const url = new URL(root.dataset.root || '/', location.origin);
          url.searchParams.set('section_id', 'peiks-catalog-count');
          url.searchParams.set('page', String(page));
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { signal: AbortSignal.any([signal, AbortSignal.timeout(15000)]), credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('Counter unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const chunk = document.querySelector('[data-peiks-count-page]');
          if (!chunk || Number(chunk.dataset.page) !== page) throw new Error('Missing count section');
          const currentTotal = Number(chunk.dataset.total), count = Number(chunk.dataset.count), variantCount = Number(chunk.dataset.variants);
          if (![currentTotal, count, variantCount].every(Number.isSafeInteger) || currentTotal < 0 || count < 0 || variantCount < count || !['true', 'false'].includes(chunk.dataset.complete)) throw new Error('Invalid counts');
          if (total === null) total = currentTotal;
          if (currentTotal !== total) throw new Error('Catalog changed');
          counted += count; variants += variantCount;
          if (chunk.dataset.complete !== 'true') complete = false;
          if (chunk.dataset.hasNext !== 'true') break;
          if (!count || page >= 100) throw new Error('Incomplete catalog');
          page++;
        }
        if (signal.aborted) return;
        const line = root.querySelector('[data-count-line]');
        const available = root.querySelector('[data-count-availability]');
        root.querySelector('[data-product-count]').textContent = counted.toLocaleString('de-DE');
        root.querySelector('[data-product-label]').textContent = counted === 1 ? 'Produkt' : 'Produkte';
        if (complete) {
          root.querySelector('[data-variant-count]').textContent = variants.toLocaleString('de-DE');
          root.querySelector('[data-variant-label]').textContent = variants === 1 ? 'verschiedenen Variante' : 'verschiedenen Varianten';
          line.hidden = false;
        } else {
          line.hidden = true;
          status.textContent = `${counted.toLocaleString('de-DE')} verfügbare Produkte · genaue Variantenanzahl zurzeit nicht verfügbar`;
        }
        if (complete) status.textContent = '';
        available.hidden = false;
      } catch {
        if (!signal.aborted) {
          root.querySelector('[data-count-line]').hidden = true;
          root.querySelector('[data-count-availability]').hidden = true;
          status.textContent = 'Verfügbare Sortimentszahlen zurzeit nicht verfügbar';
        }
      }
    }
    async loadGoogleReviews(root) {
      if (root.dataset.loaded) return;
      root.dataset.loaded = 'true';
      const status = root.querySelector('[data-google-status]');
      const safeURL = value => {
        try { const url = new URL(value); return url.protocol === 'https:' ? url.href : ''; } catch { return ''; }
      };
      const endpoint = safeURL(root.dataset.endpoint);
      if (!endpoint) return;
      status.textContent = 'Kundenstimmen werden geladen …';
      root.setAttribute('aria-busy', 'true');
      const requestController = new AbortController();
      this.controller.signal.addEventListener('abort', () => requestController.abort(), { once: true });
      const timer = setTimeout(() => requestController.abort(), 12000);
      try {
        const response = await fetch(endpoint, { signal: requestController.signal, credentials: 'omit', cache: 'no-store' });
        if (!response.ok) throw new Error('Reviews unavailable');
        const data = await response.json();
        if (data.placeId !== root.dataset.place || !Array.isArray(data.reviews)) throw new Error('Invalid review data');
        if (!root.isConnected) return;
        const cards = root.querySelector('[data-google-cards]');
        cards.replaceChildren();
        data.reviews.slice(0, 5).forEach(review => {
          const sourceURL = safeURL(review.googleMapsUri);
          if (!sourceURL || !review.authorAttribution?.displayName) return;
          const card = document.createElement('article'); card.className = 'ph-google-card';
          const author = document.createElement('div'); author.className = 'ph-google-author';
          const photoURL = safeURL(review.authorAttribution.photoUri);
          if (photoURL) { const avatar = document.createElement('img'); avatar.src = photoURL; avatar.alt = ''; avatar.width = 32; avatar.height = 32; avatar.loading = 'lazy'; avatar.referrerPolicy = 'no-referrer'; author.append(avatar); }
          const authorURL = safeURL(review.authorAttribution.uri);
          const name = document.createElement(authorURL ? 'a' : 'span'); name.textContent = review.authorAttribution.displayName;
          if (authorURL) { name.href = authorURL; name.target = '_blank'; name.rel = 'noopener noreferrer'; }
          author.append(name); card.append(author);
          const rating = document.createElement('p'); rating.className = 'ph-google-rating';
          rating.textContent = `${Number(review.rating) || 0} / 5 · ${review.relativePublishTimeDescription || ''}`; card.append(rating);
          const text = review.originalText?.text || review.text?.text || '';
          if (text.length > 240) {
            const details = document.createElement('details'); const summary = document.createElement('summary'); summary.textContent = 'Bewertung lesen';
            const body = document.createElement('p'); body.textContent = text; details.append(summary, body); card.append(details);
          } else if (text) { const body = document.createElement('p'); body.textContent = text; card.append(body); }
          const link = document.createElement('a'); link.href = sourceURL; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.textContent = 'Auf Google Maps ansehen →'; card.append(link); cards.append(card);
        });
        const summary = root.querySelector('[data-google-summary]');
        if (typeof data.rating === 'number') { summary.textContent = `${data.rating.toLocaleString('de-DE')} / 5 · ${Number(data.userRatingCount || 0).toLocaleString('de-DE')} Google-Bewertungen`; summary.hidden = false; }
        const source = root.querySelector('[data-google-source]');
        if (Array.isArray(data.attributions)) data.attributions.forEach(provider => {
          if (!provider.provider) return;
          const url = safeURL(provider.providerUri);
          const credit = document.createElement(url ? 'a' : 'span'); credit.textContent = provider.provider;
          if (url) { credit.href = url; credit.target = '_blank'; credit.rel = 'noopener noreferrer'; }
          source.append(credit);
        });
        source.hidden = false;
        status.textContent = cards.children.length ? '' : 'Weitere Kundenstimmen findest du direkt auf Google.';
        status.hidden = cards.children.length > 0;
      } catch (error) {
        if (this.controller.signal.aborted) return;
        status.textContent = 'Die Bewertungen können gerade nicht geladen werden. Du kannst sie direkt auf Google lesen.';
      } finally { clearTimeout(timer); root.removeAttribute('aria-busy'); }
    }
    disconnectedCallback() {
      window.clearInterval(this.countdownInterval);
      window.clearInterval(this.galleryInterval);
      this.googleObserver?.disconnect();
      this.controller?.abort();
      this.reviewObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
